<template>
  <div v-if="loading" class="flex items-center justify-center h-full">
    <loading-spinner diameter="64px" />
  </div>

  <alert-badge
    v-else-if="error.title"
    isDanger
    :title="error.title"
    :body="error.body"
    @dismissed="
      () => {
        error.title = ''
        error.body = ''
      }
    "
  />

  <div v-else>
    <div class="w-full mx-8 my-2">
      {{ t('views.companies.companies') }}
    </div>
    <div class="flex flex-col flex-wrap content-center m-3 md:flex-row lg:justify-start">
      <template v-if="$can('read', '/vendor/vendors')">
        <action-button
            :title="$t('views.vendors.vendors')"
            faIcon="shop"
            @click="$router.push($Route.VENDORS)"
        >
        </action-button>
      </template>
      <template v-if="$can('read', '/vendor/vendors') && useSettingsStore().getValue('show_insurance_companies_button_on_companies_page') == 'true'">
        <action-button
            :title="$t('views.insurances.insurances')"
            faIcon="medkit"
            @click="$router.push($Route.INSURANCES)"
        >
        </action-button>
      </template>
      <template v-if="$can('read', '/vendor/vendors')">
        <action-button
            :title="$t('views.deliveries.deliveries')"
            faIcon="truck"
            @click="$router.push($Route.DELIVERIES)"
        >
        </action-button>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import ActionButton from '@/components/ActionButton.vue'
import CustomIcon from '@/components/CustomIcon.vue'
import INewSale from '@/components/icons/sales/INewSale.vue'
import IReturnSale from '@/components/icons/sales/IReturnSale.vue'
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import AlertBadge from '@/components/AlertBadge.vue'

import { Register, RegisterLog } from '@/models/company/Register'
import {Order} from "@/models/sales/Order";
import {handleNewSale} from "@/lib/utils";
import {useSettingsStore} from "@/stores/settingsStore";

export default defineComponent({
  setup() {
    const { t } = useI18n({
      messages: {
        en: {
        },
        ar: {
        }
      }
    })

    return {
      t
    }
  },
  components: {
    ActionButton,
    CustomIcon,
    INewSale,
    IReturnSale,
    LoadingSpinner,
    AlertBadge
  },

  data() {
    return {
      error: {
        title: '',
        body: ''
      },
      loading: false
    }
  },

  computed: {
    registerIsOpen() {
      return this.$ctx.currentRegister.status === 'open'
    }
  },

  async beforeMount() {
    const loadRegisterStatus = async () => {
      try {
        this.loading = true
        const registerLog = await this.$http.get<RegisterLog>(
          `${Register.ENDPOINT}/last-status/${this.$ctx.currentRegister.id}`
        )

        this.$ctx.currentRegister.status = RegisterLog.from(registerLog).action
      } catch (error) {
        this.error.title = error.title
        this.error.body = error.body
      } finally {
        this.loading = false
      }
    }
    // check if the register is open or not
    loadRegisterStatus()
  },
  methods: {
    useSettingsStore,
    canWithReason(): boolean {
      return this.$can('read', 'magazine')
    },
    newSale() {
      handleNewSale(this.t);
      this.$router.push(this.$Route.SALES_NEW_SALE);
    }
  }
})
</script>

<style></style>
